import React, { useState } from 'react';
import {
    Form, Select, Input, DatePicker, Switch, Row, Col, Card, Button,
    Badge, Avatar, Tag, Modal, Radio, Tooltip
} from 'antd';
import {
    UserOutlined, CarOutlined, TeamOutlined, PlusOutlined,
    DeleteOutlined, StarFilled, StarOutlined
} from '@ant-design/icons';
import { SINISTER_COLORS } from '../../../../../components/ui/colors';

const { Option } = Select;
const { TextArea } = Input;
const listeDesCategoriesDePermis = ['AM', 'A1', 'A2', 'A', 'B', 'BE', 'C1', 'C', 'D1', 'D'].map(v => ({ value: v, label: v }));
const TAG_DOMMAGE_COLOR = { CORPOREL: 'red', MIXTE: 'orange', MATERIEL: 'blue', AUCUN: 'default' };

const AdversairesStep = ({
    adversaires, setAdversaires, adversairePrincipalId, setAdversairePrincipalId,
    assuranceOptions, cityOptions,
}) => {
    const [adversaireForm] = Form.useForm();
    const [showModal, setShowModal] = useState(false);
    const [typeAdversaire, setTypeAdversaire] = useState('VEHICULE');
    const [typeSerie, setTypeSerie] = useState('TG');
    const [typeAdversaireDommage, setTypeAdversaireDommage] = useState(null);
    const [isAdversaireConducteur, setIsAdversaireConducteur] = useState(true);

    const ajouterAdversaire = async () => {
        try {
            const values = await adversaireForm.validateFields();
            let immatriculationComplete = '';
            if (typeAdversaire?.startsWith('VEHICULE')) {
                const { typeSerie: ts, matricule, numeroSerie } = values;
                immatriculationComplete = (ts === 'TG' && numeroSerie) ? `${ts}-${matricule}-${numeroSerie}` : `${matricule || ''}`;
            }
            const newAdv = { ...values, id: Date.now(), typeAdversaire, immatriculation: immatriculationComplete };
            const newList = [...adversaires, newAdv];
            setAdversaires(newList);
            if (newList.length === 1) setAdversairePrincipalId(newAdv.id);
            adversaireForm.resetFields();
            setShowModal(false);
            setTypeAdversaireDommage(null);
        } catch { /* validation */ }
    };

    const supprimerAdversaire = (id) => {
        const remaining = adversaires.filter(a => a.id !== id);
        setAdversaires(remaining);
        if (adversairePrincipalId === id) setAdversairePrincipalId(remaining.length > 0 ? remaining[0].id : null);
    };

    return (
        <>
            <Card style={{ borderRadius: 16, boxShadow: '0 4px 12px rgba(0,0,0,0.08)' }}>
                <div style={{ background: SINISTER_COLORS.primary, padding: '10px 30px', margin: '-24px -24px 24px -24px', borderRadius: '6px 6px 0 0' }}>
                    <Row justify="space-between" align="middle">
                        <Col>
                            <h2 style={{ color: '#fff', margin: 0, fontSize: 20, fontWeight: 'bold' }}>
                                <TeamOutlined style={{ marginRight: 12 }} />Adversaires impliqués
                            </h2>
                        </Col>
                        <Col>
                            <Badge count={adversaires.length} style={{ backgroundColor: '#52c41a' }}>
                                <Button type="primary" icon={<PlusOutlined />} onClick={() => setShowModal(true)}
                                    style={{ background: '#fff', color: SINISTER_COLORS.primary, border: 'none' }}>
                                    Ajouter un adversaire
                                </Button>
                            </Badge>
                        </Col>
                    </Row>
                </div>

                {adversaires.length > 1 && (
                    <div style={{ background: '#fff8e1', padding: '10px 16px', borderRadius: 8, marginBottom: 16, border: '1px solid #ffe082', display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 8 }}>
                        <span style={{ fontWeight: 600, color: '#e65100', whiteSpace: 'nowrap' }}>
                            <StarFilled style={{ color: '#ffc107', marginRight: 6 }} />Adversaire principal :
                        </span>
                        <Radio.Group value={adversairePrincipalId} onChange={e => setAdversairePrincipalId(e.target.value)}>
                            {adversaires.map((adv, i) => (
                                <Radio key={adv.id} value={adv.id}>{adv.immatriculation || adv.nom || `Adversaire ${i + 1}`}</Radio>
                            ))}
                        </Radio.Group>
                    </div>
                )}

                {adversaires.length === 0 ? (
                    <div style={{ textAlign: 'center', padding: 40 }}>
                        <TeamOutlined style={{ fontSize: 64, color: '#d9d9d9' }} />
                        <p style={{ color: '#999', marginTop: 16 }}>Aucun adversaire ajouté</p>
                        <Button style={{ background: SINISTER_COLORS.primary }} type="primary" icon={<PlusOutlined />} onClick={() => setShowModal(true)}>
                            Ajouter le premier adversaire
                        </Button>
                    </div>
                ) : (
                    <Row gutter={[16, 16]}>
                        {adversaires.map((adv, i) => {
                            const isPrincipal = adv.id === adversairePrincipalId;
                            return (
                                <Col xs={24} sm={12} md={8} key={adv.id}>
                                    <Card size="small" style={{ height: '100%', borderLeft: isPrincipal ? '4px solid #ffc107' : '4px solid #f5576c', background: isPrincipal ? '#fffbf0' : '#fff' }}
                                        actions={[
                                            <Tooltip title={isPrincipal ? 'Adversaire principal' : 'Définir comme principal'}>
                                                <Button type="text" icon={isPrincipal ? <StarFilled style={{ color: '#ffc107' }} /> : <StarOutlined style={{ color: '#bbb' }} />}
                                                    onClick={() => setAdversairePrincipalId(isPrincipal ? null : adv.id)}>
                                                    {isPrincipal ? 'Principal' : 'Définir principal'}
                                                </Button>
                                            </Tooltip>,
                                            <Button type="text" danger icon={<DeleteOutlined />} onClick={() => supprimerAdversaire(adv.id)}>Retirer</Button>
                                        ]}>
                                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 10 }}>
                                            <Avatar icon={adv.typeAdversaire?.startsWith('VEHICULE') ? <CarOutlined /> : <UserOutlined />}
                                                style={{ background: isPrincipal ? 'linear-gradient(135deg, #ffc107 0%, #ff8f00 100%)' : 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)' }} />
                                            <div>
                                                <div style={{ fontWeight: 'bold' }}>
                                                    {isPrincipal && <StarFilled style={{ color: '#ffc107', marginRight: 4 }} />}
                                                    {adv.typeAdversaire === 'AUTRE' ? `${adv.description} – ` : ''}{adv.nom} {adv.prenom}
                                                </div>
                                                <Tag color={adv.typeAdversaire?.startsWith('VEHICULE') ? 'blue' : adv.typeAdversaire === 'PIETON' ? 'green' : 'orange'}>{adv.typeAdversaire}</Tag>
                                                {isPrincipal && <Tag color="gold">⭐ Principal</Tag>}
                                            </div>
                                        </div>
                                        {adv.immatriculation && <div style={{ fontSize: 13, color: '#666' }}><CarOutlined /> {adv.immatriculation}</div>}
                                        {adv.typeSinistre && <Tag color={TAG_DOMMAGE_COLOR[adv.typeSinistre] || 'default'} style={{ marginTop: 4 }}>{adv.typeSinistre}</Tag>}
                                    </Card>
                                </Col>
                            );
                        })}
                    </Row>
                )}
            </Card>

            <Modal title="Ajouter une partie Adverse" open={showModal}
                onCancel={() => { adversaireForm.resetFields(); setShowModal(false); setTypeSerie('TG'); setTypeAdversaireDommage(null); }}
                onOk={ajouterAdversaire} width={1100} okText="Ajouter" cancelText="Annuler" zIndex={2000} closable={false} maskClosable={false}>
                <Form form={adversaireForm} layout="vertical">
                    <Form.Item label="Type de partie adverse" name="typeAdversaire" initialValue="VEHICULE">
                        <Select style={{ width: '100%' }} onChange={v => { setTypeAdversaire(v); setTypeAdversaireDommage(null); }}>
                            <Option value="PIETON">🚶 Piéton</Option>
                            <Option value="VEHICULE">🚗 Véhiculé</Option>
                            <Option value="VEHICULE_MOTO">🏍️ Véhiculé – Moto (2 roues)</Option>
                            <Option value="VEHICULE_TRICYCLE">🛺 Véhiculé – Tricycle (3 roues)</Option>
                            <Option value="AUTRE">⚠️ Autre (Objet, Mur, etc.)</Option>
                        </Select>
                    </Form.Item>

                    {typeAdversaire === 'PIETON' && (
                        <Row gutter={16}>
                            <Col span={12}><Form.Item label="Nom" name="nom" rules={[{ required: true }]}><Input /></Form.Item></Col>
                            <Col span={12}><Form.Item label="Prénom" name="prenom" rules={[{ required: true }]}><Input /></Form.Item></Col>
                            <Col span={12}><Form.Item label="Téléphone" name="telephone"><Input /></Form.Item></Col>
                            <Col span={12}><Form.Item label="Adresse" name="adresse"><Input /></Form.Item></Col>
                        </Row>
                    )}
                    {typeAdversaire === 'AUTRE' && (
                        <Row gutter={16}>
                            <Col span={24}><Form.Item label="Nom du propriétaire" name="nom"><Input placeholder="Nom ou dénomination sociale" /></Form.Item></Col>
                            <Col span={24}><Form.Item label="Description" name="description" rules={[{ required: true }]}><Input placeholder="Ex: Mur, Poteau, Animal…" /></Form.Item></Col>
                        </Row>
                    )}
                    {typeAdversaire?.startsWith('VEHICULE') && (
                        <>
                            <Row gutter={16}>
                                <Col span={6}><Form.Item label="Nom" name="nom"><Input /></Form.Item></Col>
                                <Col span={6}><Form.Item label="Prénom" name="prenom"><Input /></Form.Item></Col>
                                <Col span={6}><Form.Item label="Téléphone" name="telephone"><Input /></Form.Item></Col>
                                <Col span={6}><Form.Item label="Adresse" name="adresse"><Input /></Form.Item></Col>
                                <Col span={8}>
                                    <Form.Item label="Immatriculation">
                                        <Input.Group compact>
                                            <Form.Item name="typeSerie" noStyle initialValue="TG">
                                                <Select style={{ width: '25%' }} onChange={v => { setTypeSerie(v); if (v !== 'TG') adversaireForm.setFieldsValue({ numeroSerie: undefined }); }}>
                                                    <Option value="TG">TG</Option>
                                                    <Option value="AUTRE">Autre</Option>
                                                </Select>
                                            </Form.Item>
                                            <Form.Item name="matricule" noStyle rules={[{ required: true, message: 'Requis' }]}>
                                                <Input style={{ width: typeSerie === 'TG' ? '45%' : '75%' }} placeholder="Ex: 1234 AB" />
                                            </Form.Item>
                                            {typeSerie === 'TG' && (
                                                <Form.Item name="numeroSerie" noStyle rules={[{ required: true, message: 'Requis' }]}>
                                                    <Input style={{ width: '30%' }} placeholder="N° série" />
                                                </Form.Item>
                                            )}
                                        </Input.Group>
                                    </Form.Item>
                                </Col>
                                <Col span={4}><Form.Item label="Marque" name="marque"><Input /></Form.Item></Col>
                                <Col span={6}><Form.Item label="Nombre de personnes transportées" name="nombrePersonnesTransportees"><Input /></Form.Item></Col>
                                <Col span={4}><Form.Item label="Vitesse (km/h)" name="vitesse"><Input /></Form.Item></Col>
                                <Col span={12}><Form.Item label="Venant de" name="provenance"><Input /></Form.Item></Col>
                                <Col span={12}><Form.Item label="Se dirigeant vers" name="destination"><Input /></Form.Item></Col>
                                <Col span={12}>
                                    <Form.Item label="Type de dommages subis" name="typeSinistre">
                                        <Select style={{ width: '100%' }} onChange={setTypeAdversaireDommage} placeholder="Sélectionner">
                                            <Option value="MATERIEL">🔧 Matériel</Option>
                                            <Option value="CORPOREL">🏥 Corporel</Option>
                                            <Option value="MIXTE">⚠️ Mixte</Option>
                                            <Option value="AUCUN">✅ Aucun</Option>
                                        </Select>
                                    </Form.Item>
                                </Col>
                                <Col span={12}>
                                    <Form.Item label="Société d'assurance adverse" name="societeAssurance">
                                        <Select style={{ width: '100%' }} options={assuranceOptions} />
                                    </Form.Item>
                                </Col>
                            </Row>
                            {(typeAdversaireDommage === 'MATERIEL' || typeAdversaireDommage === 'MIXTE') && (
                                <Form.Item label={<b>🔧 Description des dégâts matériels</b>} name="descriptionDegatsMateriels" rules={[{ required: true }]}>
                                    <TextArea rows={3} placeholder="Décrire les dommages matériels…" />
                                </Form.Item>
                            )}
                            {(typeAdversaireDommage === 'CORPOREL' || typeAdversaireDommage === 'MIXTE') && (
                                <Form.Item label={<b>🏥 Description des dommages corporels subis par le conducteur</b>} name="descriptionDegatsCorporels" rules={[{ required: true }]}>
                                    <TextArea rows={3} placeholder="Décrire les dommages corporels…" />
                                </Form.Item>
                            )}
                            <Form.Item label={<b>La partie adverse était-elle le conducteur ?</b>}>
                                <Switch checked={isAdversaireConducteur} onChange={(v, e) => { e.stopPropagation(); setIsAdversaireConducteur(v); }}
                                    checkedChildren="Oui" unCheckedChildren="Non" style={{ background: isAdversaireConducteur ? '#52c41a' : '#d9d9d9' }} />
                            </Form.Item>
                            <div style={{ background: 'linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%)', padding: 16, borderRadius: 6 }}>
                                <h4 style={{ color: '#1565c0', marginBottom: 12 }}>
                                    <CarOutlined style={{ marginRight: 8 }} />Permis {isAdversaireConducteur ? 'de la partie adverse' : 'du conducteur adverse'}
                                </h4>
                                {!isAdversaireConducteur && (
                                    <Row gutter={16}>
                                        <Col xs={24} sm={12}><Form.Item label={<b>Nom</b>} name={['conducteur', 'nom']} rules={[{ required: true }]}><Input /></Form.Item></Col>
                                        <Col xs={24} sm={12}><Form.Item label={<b>Prénom</b>} name={['conducteur', 'prenom']} rules={[{ required: true }]}><Input /></Form.Item></Col>
                                        <Col xs={24} sm={12}><Form.Item label={<b>Téléphone</b>} name={['conducteur', 'telephone']}><Input /></Form.Item></Col>
                                        <Col xs={24} sm={12}><Form.Item label={<b>Adresse</b>} name={['conducteur', 'adresse']}><Input /></Form.Item></Col>
                                    </Row>
                                )}
                                <Row gutter={16}>
                                    <Col xs={24} sm={12}><Form.Item label={<b>N° permis</b>} name={['permis', 'numero']}><Input /></Form.Item></Col>
                                    <Col xs={24} sm={12}><Form.Item label={<b>Catégorie</b>} name={['permis', 'categorie']}><Select options={listeDesCategoriesDePermis} /></Form.Item></Col>
                                    <Col xs={24} sm={12}><Form.Item label={<b>Date d'obtention</b>} name={['permis', 'dateObtention']}><DatePicker disabledDate={c => c && c > new Date()} style={{ width: '100%' }} /></Form.Item></Col>
                                    <Col xs={24} sm={12}><Form.Item label={<b>Lieu d'obtention</b>} name={['permis', 'lieuObtention']}><Select options={cityOptions} style={{ width: '100%' }} /></Form.Item></Col>
                                </Row>
                            </div>
                        </>
                    )}
                </Form>
            </Modal>
        </>
    );
};

export default AdversairesStep;
